import { SvgIcon } from '../../../mui/SvgIcon';
import { UxSvgIconProps } from '../ux/types';

export function BpPeople(props: Omit<UxSvgIconProps, 'preserveAspectRatio' | 'viewBox'>) {
  return (
    <SvgIcon {...props} preserveAspectRatio='xMidYMid meet' viewBox='0 0 16 16'>
      <path
        d='M13.69,13.98c-0.05-0.24-0.14-0.5-0.25-0.76c-0.36-0.86-1.12-1.33-2.69-2
			c-0.14-0.06-0.59-0.25-0.6-0.25c-0.21-0.09-0.36-0.15-0.5-0.22c0.02-0.1,0.02-0.2,0.03-0.31c0-0.04,0.01-0.08,0.01-0.13
			c-0.07-0.06-0.13-0.12-0.19-0.19c0.22-0.32,0.4-0.67,0.54-1.05c0.02-0.06,0.02-0.06,0.03-0.1c0.29-0.23,0.48-0.57,0.59-0.96
			c0.16-0.33,0.25-0.73,0.21-1.16c-0.03-0.4-0.16-0.76-0.37-1.03c-0.02-0.53-0.07-1.13-0.15-1.54c-0.01-0.06-0.02-0.12-0.03-0.19
			C10.55,4.03,10.8,4,11.04,4c0.49,0,1.05,0.16,1.44,0.46c0.38,0.29,0.67,0.7,0.8,1.17c0.03,0.1,0.05,0.21,0.07,0.31
			c0.07,0.37,0.11,0.94,0.11,1.33c0,0.02,0,0.04,0,0.05c0.14,0.06,0.27,0.21,0.29,0.51c0.02,0.25-0.07,0.45-0.13,0.54
			c-0.05,0.21-0.16,0.44-0.38,0.48c-0.02,0.1-0.05,0.2-0.09,0.3c0,0.01-0.01,0.03-0.01,0.03c-0.17,0.44-0.43,0.83-0.75,1.11
			c0,0.05,0,0.1,0,0.14c0.03,0.35-0.09,0.59,0.83,1c0.93,0.41,2.32,0.84,2.6,1.5c0.29,0.66,0.17,1.04,0.17,1.04H13.69z M12.52,13.6
			c0.37,0.86,0.22,1.36,0.22,1.36H0.06c0,0-0.14-0.5,0.22-1.36s2.13-1.43,3.31-1.96c1.17-0.54,1.05-0.86,1.09-1.3
			c0-0.05,0.01-0.11,0.01-0.17C4.28,9.82,3.94,9.31,3.72,8.72V8.71c0,0-0.01-0.01-0.01-0.02C3.67,8.57,3.62,8.43,3.59,8.3
			c-0.28-0.05-0.44-0.36-0.5-0.64C3.03,7.54,2.9,7.27,2.93,6.95c0.04-0.41,0.21-0.6,0.39-0.68c0-0.02,0-0.04,0-0.06
			c0-0.51,0.05-1.26,0.14-1.74C3.48,4.34,3.51,4.2,3.55,4.07c0.17-0.6,0.54-1.13,1.02-1.51c0.5-0.39,1.21-0.6,1.84-0.6
			s1.34,0.21,1.84,0.6C8.73,2.94,9.1,3.47,9.27,4.08c0.04,0.13,0.07,0.27,0.09,0.4C9.45,4.96,9.5,5.7,9.5,6.21c0,0.02,0,0.05,0,0.07
			c0.18,0.08,0.34,0.27,0.37,0.67C9.9,7.27,9.78,7.54,9.71,7.66C9.65,7.94,9.5,8.24,9.23,8.29C9.2,8.42,9.16,8.55,9.11,8.68
			c0,0.01-0.01,0.04-0.01,0.04C8.88,9.3,8.55,9.8,8.15,10.17c0,0.06,0,0.13,0,0.18c0.04,0.45-0.12,0.77,1.06,1.3
			C10.39,12.18,12.16,12.74,12.52,13.6z'
      />
    </SvgIcon>
  );
}
